import { useEffect, useRef, useState } from 'react';
import { shortcuts } from '@myua/api';
import { urlSearchUpload } from '../../../api';
import { UploadData } from '../model';
import { message } from '@myua/kit';

export function useUploader({
  onSuccess,
  onError,
}: {
  onSuccess: (newUploadData: UploadData) => void;
  onError: () => void;
}) {
  const abortControllerRef = useRef<AbortController | null>(null);
  const [isUploading, setIsUploading] = useState(false);

  const upload = (file: File) => {
    abortControllerRef.current?.abort();

    const controller = new AbortController();
    abortControllerRef.current = controller;

    const formData = new FormData();
    formData.append('file', file);

    setIsUploading(true);

    shortcuts
      .post<{ search_upload_id: number }>({
        url: urlSearchUpload(),
        payload: formData,
        signal: controller.signal,
      })
      .then((result) => {
        onSuccess({ id: result.response.search_upload_id, fileName: file.name });
      })
      .catch((err) => {
        if (err?.error?.name === 'AbortError') {
          return;
        }
        void message.error('Failed to upload file for search');
        onError();
      })
      .finally(() => {
        if (abortControllerRef.current === controller) {
          setIsUploading(false);
        }
      });
  };

  useEffect(() => {
    return () => {
      abortControllerRef.current?.abort();
    };
  }, []);

  return { upload, isUploading, abort: () => abortControllerRef.current?.abort() };
}
